"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { Button, Box as MantineBox } from "@mantine/core";
import Link from "@/components/Link";
import { infoLinks } from "@/lib/shared/constants";

import styles from "./styles.module.scss";

interface InfoMenuProps {
  isOpen: boolean;
  onToggle: () => void;
}

const InfoMenu = ({ isOpen, onToggle }: InfoMenuProps) => {
  const pathname = usePathname();

  useEffect(() => {
    if (isOpen) {
      onToggle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <MantineBox
      className={styles.infoMenuContainer}
      onMouseEnter={() => {
        if (!isOpen) onToggle();
      }}
      onMouseLeave={() => {
        if (isOpen) onToggle();
      }}
    >
      <Button onClick={onToggle} variant="unstyled" aria-expanded={isOpen}>
        INFO
      </Button>
      <MantineBox className={styles.infoMenu} data-open={isOpen}>
        {infoLinks.map(({ name, url }) => (
          <Link key={name} href={url} prefetch={false} data-active={pathname === url}>
            {name}
          </Link>
        ))}
      </MantineBox>
    </MantineBox>
  );
};

export default InfoMenu;
